// PRD 08 §10.1 + Slice C3 — corpus settings dashboard route.
//
// Standalone for v1; folds into a /corpora/:id/review Settings tab once
// the corpus-level review surface lands.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { CorpusSettingsForm } from "../review/corpus/CorpusSettingsForm";

export const corpusSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/corpora/$corpusId/settings",
  component: CorpusSettingsPage,
});

function CorpusSettingsPage() {
  const { corpusId } = corpusSettingsRoute.useParams();
  return (
    <div className="maisight-corpus-page">
      <header className="maisight-corpus-page-header">
        <h1>Corpus settings</h1>
        <code className="maisight-corpus-id">{corpusId}</code>
      </header>
      <CorpusSettingsForm corpusId={corpusId} />
    </div>
  );
}
